

const systemPages = ['rooms', 'profile', 'data-analytics', 'ref', 'organization', 'billing', 'global-chats', '', 'undefined', 'tariffs'];
export const technicalPages = ['endedTariff', 'awaitingPayment']

export const getKeyFromLocation = (location: string, roomFromParams?: string) => {
  if (location.includes('/mobile')) return 'mobile';
  if (location.includes('/organization')) return 'organization';
  if (location.includes('/rooms')) return 'rooms';
  if (location.includes('/profile')) return 'profile';
  if (location.includes('/data-analytics')) return 'data-analytics';
  if (location.includes('/report')) return 'report';
  if (location.includes('/ref')) return 'ref';
  if (location.includes('/billing')) return 'billing';

  const previousPage = roomFromParams && location.replace(`/room/${roomFromParams}/`,'').split('/')[0]
  const isChatPrevious = previousPage === 'chat' ? location.replace(`/room/${roomFromParams}/`,'').split('/')[1] : null;
  const currentKey = isChatPrevious ? `${previousPage}/${isChatPrevious}` : String(previousPage);
  return currentKey
};

export default systemPages;
